import { useNavigate, useSearch } from '@tanstack/react-router';
import { useState, type JSX } from 'react';
import { Page, PageHeader } from '@/components/layout/page.js';
import { Button } from '@/components/ui/button.js';
import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle } from '@/components/ui/sheet.js';
import { CarrierCoverageMatrix } from './carrier-coverage-matrix.js';
import { CarrierRulesTable } from './carrier-rules-table.js';
import { CarrierSimulator } from './carrier-simulator.js';
import { readTransporteursSearch } from './search-params.js';

export function TransporteursPage(): JSX.Element {
  const rawSearch: unknown = useSearch({ strict: false });
  const navigate = useNavigate();
  const { tab, store } = readTransporteursSearch(rawSearch);
  const [open, setOpen] = useState(tab === 'simulateur');
  return <Page>
    <PageHeader title="Transporteurs" description="Les règles sont évaluées de haut en bas : la première correspondance décide du code transmis à Martelet."
      actions={<Button type="button" variant="outline" onClick={() => setOpen(true)}>Simuler une commande</Button>} />
    <CarrierRulesTable suggestionsStore={store} />
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetContent className="sm:max-w-4xl">
        <SheetHeader><SheetTitle>Simulateur et couverture</SheetTitle><SheetDescription>Vérifiez le résultat d’une règle et la couverture d’une boutique.</SheetDescription></SheetHeader>
        <div className="flex flex-col gap-6"><CarrierSimulator suggestionsStore={store} /><CarrierCoverageMatrix store={store} onStoreChange={(next) => {
          void navigate({ to: '.', search: (prev: Record<string, unknown>) => ({ ...prev, store: next }), replace: true });
        }} /></div>
      </SheetContent>
    </Sheet>
  </Page>;
}
